module.exports = __webpack_public_path__ + "static/media/StarvingPanda.003a4442.jpg";